import $http from '../../shared/http';
import Vue from 'vue';

const preferences = {
  namespaced: true,
  state: () => {
    return {
      hiddenAlertsLoading: false,
      userPreferences: {
        hidden_alerts: {},
      },
      locale: null,
    };
  },
  getters: {
    GET_ALL_USER_PREFERENCES: (state) => state.userPreferences,
    GET_ALL_HIDDEN_ALERTS: (state) => state.userPreferences?.hidden_alerts,
    GET_HIDDEN_ALERTS_LOADING_STATE: (state) => state.hiddenAlertsLoading,
    GET_LOCALE: (state) => state.locale,
  },
  mutations: {
    dismissAlert: (state, { value, name, desc }) => {
      if (!state.userPreferences?.hidden_alerts) {
        // Vue 2 reactivity caveat
        Vue.set(state.userPreferences, 'hidden_alerts', {});
      }
      // Vue 2 reactivity caveat
      Vue.set(state.userPreferences.hidden_alerts, name, {
        desc,
        value,
      });
    },
    setLocale(state, payload) {
      state.locale = payload;
    },
    setUserPreferences(state, preferences) {
      state.userPreferences = preferences;
    },
  },
  actions: {
    async SAVE_USER_PREFERENCES({ commit }, { form, userId, silent }) {
      return $http('v2')
        .post(`users/${userId}/preferences`, form, {
          notifiable: !silent,
        })
        .then(async (response) => {
          commit('setUserPreferences', response.data.data);
          return response.data.data;
        });
    },

    async DISMISS_ALERT_ACTION({ commit, dispatch }, payload) {
      if (Array.isArray(payload) || typeof payload !== 'object') {
        throw new Error(
          'Payload is required and should contain "dontShowAgain" and "identifier" keys'
        );
      }

      const { dontShowAgain = false, identifier, userId } = payload;

      /**
       * Value is always `true` and it portrays the intention to dismiss
       */
      const value = true;

      commit('dismissAlert', { value, ...identifier });

      if (dontShowAgain) {
        return dispatch('SAVE_USER_PREFERENCES', {
          form: { hidden_alerts: { [identifier.name]: { desc: identifier.desc, value } } },
          userId,
        });
      }
    },

    async SAVE_ALERT_PREFERENCES_ACTION({ dispatch }, identifier) {
      return dispatch('SAVE_USER_PREFERENCES', {
        form: {
          hidden_alerts: { [identifier.name]: { desc: identifier.desc, value: identifier.value } },
        },
        userId: identifier.userId,
      });
    },

    /**
     * Called from the `auth` module after `auth_profile` is fetched.
     */
    setUserPreferences({ commit }, preferences) {
      commit('setUserPreferences', preferences);
    },
  },
};

export default preferences;
